
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ArticlePagination',
  props: {
    currentPage: { type: Number, default: 1 },
    totalPage: { type: Number, default: 1 }
  },
  computed: {
    isShowArrowPrev() {
      return this.currentPage > 1
    },
    isShowArrowNext() {
      return this.currentPage < this.totalPage
    },
    pagesToShow() {
      const pages: (number | string)[] = []
      const { currentPage, totalPage } = this

      const addRange = (start: number, end: number) => {
        for (let i = start; i <= end; i++) {
          pages.push(i)
        }
      }

      if (totalPage <= 5) {
        addRange(1, totalPage)
        return pages
      }

      pages.push(1)

      if (currentPage <= 2) {
        addRange(2, 3)
        pages.push('dot-right')
      } else if (currentPage === 3) {
        addRange(2, 4)
        pages.push('dot-right')
      } else if (currentPage === totalPage - 2) {
        pages.push('dot-left')
        addRange(totalPage - 3, totalPage - 1)
      } else if (currentPage >= totalPage - 1) {
        pages.push('dot-left')
        addRange(totalPage - 2, totalPage - 1)
      } else {
        pages.push('dot-left')
        addRange(currentPage - 1, currentPage + 1)
        pages.push('dot-right')
      }

      pages.push(totalPage)
      return pages
    }
  },
  methods: {
    goToPage(page: number | string) {
      if (typeof page === 'number' && page >= 1 && page <= this.totalPage) {
        this.$emit('goPage', page)
      }
    }
  }
})
